export default "__VITE_ASSET__Dnoo4pt8__"